import { Button, Typography } from "@plum-xoxo/admin-dsm";
import React from "react";
import { app_path } from "config";
import { useHistory } from "react-router-dom";

const EmptyReportBtn = ({ title, tableData, kyb_status }) => {
  let link = "";
  let btnTitle = "";
  let routeTitle = "wallet-balance";
  const history = useHistory();
  if (kyb_status === 0 || kyb_status === 3) {
    link = "accounts/platform-preferences";
    btnTitle = "Verify Business Details";
    routeTitle = "account";
  } else if (title === "payments" || title === "redemption history") {
    link = "recharge";
    btnTitle = "Add Funds";
  } else if (title === "gift cards") {
    link = "generate-brand-voucher/";
    btnTitle = "Send Gift Cards";
  } else {
    link = title.replace("reward", "xoxo").replace(" ", "-");
    btnTitle = `Send ${tableData?.title}`;
  }
  return kyb_status === 1 ? null : (
    <div
      onClick={() => {
        history.push({
          pathname: `/${app_path}/${link}`,
          title: routeTitle,
        });
      }}
    >
      <Button>{btnTitle}</Button>
    </div>
  );
};

export default EmptyReportBtn;
